import { render } from "./ReCaptchaSubmit.vue?vue&type=template&id=6f2c7b42&ts=true"
import script from "./ReCaptchaSubmit.vue?vue&type=script&lang=ts"
export * from "./ReCaptchaSubmit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__